import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { FirebaseService } from './firebase.service';
import { StateService } from './state.service';

export const firebaseInitializerResolver: ResolveFn<boolean> = (route, state) => {
  const firebaseService = inject(FirebaseService);
  const stateService = inject(StateService)

  if (stateService.getFirebaseUser()) {
    return of(true);
  }

  return firebaseService.initializeFirebase().pipe(
    map(() => true),
    catchError(error => {
      console.error('Error during Firebase initialization: ', error);
      return of(false);
    }),
  );
};
